module.exports = __webpack_public_path__ + "img/about-tream.d1a5d0f1.png";